import BottomText from './textTypes/BottomText';
import CenterText from './textTypes/CenterText';

const slideTextTypes = {
  BottomText,
  CenterText
};

export default slideTextTypes;



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/slideTextTypes.js